module.exports = "<div class=\"favorite nratv-add-list\" data-gtm-event-click=\"Add\" data-gtm-component=\"Reaction\" [attr.data-gtm-label]=\"item.slug\" [ngClass]=\"{ 'selected' : favorite === true}\" (click)=\"onClick($event)\">ADD</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-player/controls/vg-favorite/vg-favorite.template.html
// module id = 793
// module chunks = 2